import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=16481b0c&scoped=true&"
import script from "./VForm.vue?vue&type=script&lang=js&"
export * from "./VForm.vue?vue&type=script&lang=js&"
import style0 from "./VForm.vue?vue&type=style&index=0&id=16481b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16481b0c",
  null
  
)

export default component.exports